import { component } from './component';
import { breadcrumb } from './breadcrumb';
import { unit } from './unit';
import { validation_errors } from './validation_errors';

export const shared = {
  component,
  breadcrumb,
  unit,
  validation_errors,
  template: {
    footer: {
      email: 'Email address'
    }
  },

  date: {
    last_mounth: 'last mounth',
    '3_mounths': '3 mounths',
    '6_mounths': '6 mounths',
    year: 'year',
    all_period: 'all period'
  },

  error_page: {
    403: {
      title: 'Access is denied',
      description: 'We are working on it'
    },
    404: {
      title: 'Sorry, the page you are looking for can’t be found.',
      description: 'Sorry, the page you are looking for can’t be found.'
    },
    500: {
      title: 'Internal',
      description: 'We are working on it'
    },
    520: {
      title: 'Unknown error',
      description: 'We are working on it'
    },

    link: {
      to_index: 'To Main page'
    }
  },
  referrer: {
    old_version: 'The old version of the personal account is no longer supported. Please log in to the new version to get all the benefits of our service.'
  },
  errors: {
    incorrect_login: 'The username or password is incorrect',
    authorisation: 'Authorisation Error',
    input_form: 'Fill the form',
    'The given data was invalid.': 'Invalid request'
  },
  loading: 'Loading',
  select: 'Select',
};
